import * as Phaser from "phaser";

export class ImageStatIndicator2 extends Phaser.GameObjects.Container {
  private image: Phaser.GameObjects.Image;
  private overlayRect: Phaser.GameObjects.Rectangle;
  private value: number = 100;
  private maskShape?: Phaser.GameObjects.Graphics;

  constructor(
    scene: Phaser.Scene,
    x: number,
    y: number,
    texture: string,
    frame?: string,
    scale: number = 1,
    cornerRadius: number = 12,
  ) {
    super(scene, x, y);

    // создаем image и overlay
    this.image = scene.add.image(0, 0, texture, frame);
    this.image.setScale(scale);
    this.image.setOrigin(0.5, 0.5);

    const scaledWidth = this.image.width * scale;
    const scaledHeight = this.image.height * scale;

    this.overlayRect = scene.add.rectangle(
      0,
      0,
      scaledWidth,
      scaledHeight,
      0x00ff00,
      0.4,
    );
    this.overlayRect.setOrigin(0.5, 1);

    this.add(this.overlayRect);
    this.add(this.image);

    // Маску создаём ЧУТЬ ПОЗЖЕ, чтобы контейнер был добавлен в сцену
    scene.events.once(Phaser.Scenes.Events.UPDATE, () => {
      if (cornerRadius > 0) {
        const worldPos = this.getWorldTransformMatrix().decomposeMatrix();
        const maskGraphics = scene.add.graphics();

        maskGraphics.fillStyle(0xffffff);
        maskGraphics.fillRoundedRect(
          worldPos.translateX - scaledWidth / 2,
          worldPos.translateY - scaledHeight / 2,
          scaledWidth,
          scaledHeight,
          cornerRadius,
        );

        const mask = maskGraphics.createGeometryMask();

        // Применяем маску к image и overlay
        this.image.setMask(mask);
        this.overlayRect.setMask(mask);

        maskGraphics.setVisible(false);
        this.maskShape = maskGraphics;
        this.mask = mask;
      }
    });

    this.setValue(100);
  }

  setValue(value: number | null): void {
    if (value == null) return;
    this.value = Math.max(0, Math.min(100, value));
    this.updateOverlay();
  }

  private updateOverlay(): void {
    if (!this.overlayRect || !this.overlayRect.active) {
      return;
    }

    const scaledHeight = this.image.height * this.image.scale;
    const newOverlayHeight = (scaledHeight * this.value) / 100;
    const overlayY = scaledHeight / 2;

    this.overlayRect.setSize(this.overlayRect.width, newOverlayHeight);
    this.overlayRect.setPosition(0, overlayY);
    this.overlayRect.setVisible(newOverlayHeight > 0);

    // Обновляем цвет заливки по значению: 0% — красный, 100% — зелёный
    const color = this.computeColorByValue(this.value);
    this.overlayRect.setFillStyle(color, 0.3);
  }

  getValue(): number {
    return this.value;
  }

  override destroy(fromScene?: boolean): void {
    this.maskShape?.destroy();
    super.destroy(fromScene);
  }

  private computeColorByValue(value: number): number {
    const t = Math.max(0, Math.min(100, value)) / 100; // 0 → 1
    let r: number;
    let g: number;
    const b = 0;

    if (t >= 0.5) {
      // 50% (жёлтый) → 100% (зелёный): R 255→0, G остаётся 255
      const u = (t - 0.5) / 0.5; // 0 → 1
      r = Math.round(255 * (1 - u));
      g = 255;
    } else {
      // 0% (красный) → 50% (жёлтый): R остаётся 255, G 0→255
      const u = t / 0.5; // 0 → 1
      r = 255;
      g = Math.round(255 * u);
    }

    return (r << 16) | (g << 8) | b;
  }
}
